// extracted by mini-css-extract-plugin
module.exports = {"logo":"CardImageLogo_logo__1P5z7","logo-image":"CardImageLogo_logo-image__20RFE","avant-logo":"CardImageLogo_avant-logo__lSDvG","marker":"CardImageLogo_marker__YT9KS"};